<template>
	 <div class="row mt-2">
		  <div class="col-md-12 mb-5">
			   <h2>Admin panel</h2>
			   <a href="#/backoffice/admin/userForm/" class="btn btn-primary btn-sm">Add user</a>
		  </div>

		  <div class="d-inline-flex col-md-12 mb-1 row">
			   <div class="col-md-2">
					<select class="custom-select" @change="archiveFilter($event)">
						 <option selected value="onlyActive">only active</option>
						 <option value="onlyArchive">only archived</option>
						 <option value="all">all</option>
					</select>
			   </div>
		  </div>

		  <div class="table-responsive col-md-12">
			   <table class="table table-bordered table-hover">
					<thead>
					<tr>
						 <th>name</th>
						 <th>email</th>
						 <th>phone</th>
						 <th>demo</th>
						 <th>actions</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="user in usersList">
						 <th>
							  {{user.company_name}}
							  <span v-if="user.isArchived" class="badge badge-warning">archived</span>
						 </th>
						 <th>{{user.company_email}}</th>
						 <th>{{user.company_phone}}</th>
						 <th>
							  <b>
								   <span class="fas" :class='{
											 "fa-gift text-warning": user.isDemoUser,
											 "fa-euro-sign text-success": !user.isDemoUser
										 }'></span>
							  </b>
						 </th>
						 <th>
							  <template v-if="!user.isArchived">
								   <a :href="'#/backoffice/admin/userForm/'+user._id" class="mr-1">Edit</a>
								   <a :href="'#/backoffice/admin/statistics/'+user._id" class="mr-1">Stats</a>
								   <button class="btn btn-sm btn-success mr-1" v-on:click="onLoginAs(user)">login</button>

								   <button class="btn btn-warning btn-sm mr-1"
										   v-on:click="onArchive(user)">
										Archive
								   </button>
							  </template>
							  <template  v-if="user.isArchived">
								   <button class="btn btn-danger btn-sm mr-1"
										   v-on:click="onDelete(user)">
										Delete
								   </button>
								   <button class="btn btn-info btn-sm mr-1"
										   v-on:click="onActivate(user)">
										Activate
								   </button>
							  </template>
						 </th>
					</tr>
					</tbody>
			   </table>
		  </div>
	 </div>
</template>

<script>
	import ApiService from "../../../libs/ApiService";

	export default {
		name: "Admin",
		data() {
			return {
				usersList: [],
				showArchive: false,
				searchParams: {
					archiveFilter: 'onlyActive'
				}
			}
		},
		methods: {
			async loadUsers() {
				this.usersList = [];
				let {data} = await ApiService.get('/admin/user', {params: this.searchParams});
				if (!data) {
					alert("problem with the request");
					return;
				}
				this.usersList = data;
			},
			async onLoginAs(user) {
				await ApiService.post('/admin/loginAs/' + user._id);
				await this.$store.dispatch('me/loadFromServer');
				this.$router.push("/backoffice/dashboard");

			},
			async onArchive(user) {
				let approve = confirm("ARE YOU SURE TO ARCHIVE \n" + user.company_name + "\n" + user.company_email +
					"\n THIS USER WILL BE FOUND UNDER ARCHIVE FILTER");
				if (approve) {
					let data = {
						isArchived: true
					}
					await ApiService.put('/admin/user/' + user._id, data).then(this.loadUsers);
					this.loadUsers();
				}
			},
			async onDelete(user) {
				let approve = confirm("ARE YOU SURE TO PERMANENTLY DELETE \n" + user.company_name + "\n" + user.company_email);
				if (approve) {
					await ApiService.delete('/admin/user/' + user._id).then(this.loadUsers);
					this.loadUsers();
				}
			},
			async onActivate(user) {
				let approve = confirm("ARE YOU SURE TO ACTIVATE \n" + user.company_name + "\n" + user.company_email);
				if (approve) {
					let data = {
						isArchived: false
					}
					await ApiService.put('/admin/user/' + user._id, data).then(this.loadUsers);
					this.loadUsers();
				}
			},
			archiveFilter($event) {
				this.searchParams.archiveFilter = $event.target.value;
				this.loadUsers();
			}
		},
		created() {
			this.loadUsers();
			if (!this.$store.state.me.user.isAdmin){
				this.$router.push("/backoffice/dashboard");
			}

		}
	}
</script>

<style scoped>

</style>
